import React, { useState } from 'react'
import './Footer.css'
import { Link } from 'react-router-dom'
import PerformanceTour from '../Header/PerformanceTour';
import CompanionTour from '../Header/CompanionTour';
import assets from '../../assets/assets';

export default function Footer({ setFooter, footer, changeActiveMenuHome, changeActiveMenuHw, changeActiveMenuSummary, changeActiveMenuEngage }) {
  const FooterActive = localStorage.getItem("footerActive") || "Home";
  const [clickPer, setClickPer] = useState(false)
  const [clickCom, setClickCom] = useState(false)

  const handleClickHome = (newActiveMenu) => {
    changeActiveMenuHome(newActiveMenu);
  };

  const handleClickHW = (newActiveMenu) => {
    changeActiveMenuHw(newActiveMenu);
  };
  const handleClickDCM = (newActiveMenu) => {
    changeActiveMenuSummary(newActiveMenu);
  };
  const handleClickEngaggement = (newActiveMenu) => {
    changeActiveMenuEngage(newActiveMenu);
  };

  return (
    <div className='FoterDetailContainer d-flex justify-content-center' >
      <div className='d-flex FoterDetailSubContainer'>

        <div className='FooterTextContainer home' onClick={(e) => {
          setFooter({ footerMenu: 'Home' }); localStorage.setItem("footerActive", 'Home')
          handleClickHome('Dashboard')
        }} >
          <Link className='link linkUnder' to='/HomePage'>
            <div className='d-flex justify-content-center'>
              {FooterActive === 'Home' ? <img src={assets.DashboaredActiveIcon} alt='icon'></img> : <img src={assets.DashboaredActiveFooterIcon} alt='icon'></img>}
            </div>
            <div className={` ${FooterActive === 'Home' ? "active d-flex justify-content-center mt-2 ActivefooterDetailHeading" : "d-flex justify-content-center mt-2 footerDetailHeading"}`}>Dashboard</div>
          </Link>
        </div>


        <div className='FooterTextContainer digitalClass' onClick={(e) => { setFooter({ footerMenu: 'DCM' }); localStorage.setItem("footerActive", 'DCM'); localStorage.setItem("assessSubMenu", "pending"); handleClickDCM('Summary') }} >
          <Link className='link linkUnder' to='/Summary'>
            <div className='d-flex justify-content-center'>
              {FooterActive === 'DCM' ? <img src='/StudentImg/DcmActive.png' alt='icon'></img> : <img src='/StudentImg/DcmIcon.png' alt='icon'></img>}
            </div>
            <div className={` ${FooterActive === 'DCM' ? "active d-flex justify-content-center mt-2 ActivefooterDetailHeading" : "d-flex justify-content-center mt-2 footerDetailHeading"}`}>Digital.Class</div>
          </Link>
        </div>

        <div className="homeWork" style={{ cursor: 'pointer' }} onClick={(e) => { setFooter({ footerMenu: 'HMW' }); localStorage.setItem("footerActive", 'HMW'); localStorage.setItem("hwSubMenu", "pending"); localStorage.setItem("actSub", "pending"); localStorage.setItem("summarySideMenu", "Summary"); handleClickHW('Homework') }}>
          <Link className='link linkUnder' to='/Homework'>
            <div className='d-flex justify-content-center' >
              {FooterActive === 'HMW' ? <img src={assets.AssignmentActiveIcon} alt='icon'></img> : <img src={assets.AssignmentIcon} alt='icon'></img>}
            </div>
            <div className={` ${FooterActive === 'HMW' ? "active d-flex justify-content-center mt-2 ActivefooterDetailHeading" : "d-flex justify-content-center mt-2 footerDetailHeading"}`}>Smart.Assignment</div>
          </Link>
        </div>

        <div style={{ cursor: 'pointer' }} className='Engagement' onClick={(e) => { setFooter({ footerMenu: 'Engagement' }); localStorage.setItem("footerActive", 'Engagement'); handleClickEngaggement('Community') }}>
          <Link className='link linkUnder' to='/EngagementCommunity'>
            <div className='d-flex justify-content-center' >
              {FooterActive === 'Engagement' ? <img src={assets.EngagementActiveIcon} alt='icon'></img> : <img src={assets.EngagementIcon} alt='icon'></img>}
            </div>
            <div className={` ${FooterActive === 'Engagement' ? "active d-flex justify-content-center mt-1 ActivefooterDetailHeading" : "d-flex justify-content-center mt-1 footerDetailHeading"}`}>Engagement</div>
          </Link>
        </div>
        <div style={{ cursor: 'pointer' }}>
          <Link className='link linkUnder'>
            <div onClick={() => setClickPer(true)} >
              <div className='d-flex justify-content-center' >
                <img src={assets.PerformanceIcon} alt="icon"></img>
              </div>
              <div className="footerDetailHeading" style={{ marginTop: "4px" }}>Performance.AI</div>
            </div>
          </Link>
        </div>
        <div>
          <Link className='link linkUnder'>
            <div onClick={() => setClickCom(true)} style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
              <img src="/DCM-img/UnActiveEngg.png" alt="icon" style={{ width: "20px", marginTop: "3px", opacity: "0.9", zIndex: "revert-layer" }}></img>
              <div className="footerDetailHeading" style={{ marginTop: "5px" }}>Companion.AI</div>
            </div>
          </Link>
        </div>
      </div>
      {
        clickPer && <PerformanceTour setClick={setClickPer} />
      }
      {
        clickCom && <CompanionTour setClick={setClickCom} />
      }
    </div >
  )
}
